import { useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";

const LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "stories", label: "Stories" },
  { id: "careers", label: "Careers" },
  { id: "contact", label: "Contact" },
];

export function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

export default function Nav() {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToSection(id), 60);
  };

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-silver"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center"
        >
          <img src="/logo.png" alt="Karen's Caring Hands, LLC" className="h-14 md:h-20 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToSection(l.id)}
              className="text-xs font-semibold uppercase tracking-[0.2em] text-navy-dark/70 hover:text-navy transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-button"
            onClick={() => scrollToSection("contact")}
            className="group hidden sm:inline-flex items-center gap-2 bg-navy-dark text-white text-xs font-semibold uppercase tracking-[0.18em] px-6 py-3.5 rounded-full hover:bg-navy transition-colors duration-300"
          >
            Request Care
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <button
            data-testid="nav-menu-button"
            onClick={() => setOpen(!open)}
            aria-label="Open menu"
            className="md:hidden inline-flex items-center justify-center w-11 h-11 border border-silver text-navy-dark hover:bg-silver-light transition-colors duration-300"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-silver bg-white px-6 py-8 flex flex-col gap-6">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-sm font-semibold uppercase tracking-[0.2em] text-navy-dark/80 hover:text-navy transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta"
            onClick={() => go("contact")}
            className="mt-2 inline-flex items-center justify-center gap-2 bg-navy-dark text-white text-xs font-semibold uppercase tracking-[0.18em] px-6 py-4 rounded-full"
          >
            Request Care
            <ArrowUpRight className="w-3.5 h-3.5" />
          </button>
        </div>
      )}
    </header>
  );
}
